<template>
  <thead class="bg-color-1 dark:bg-dark-700">
    <slot></slot>
  </thead>
</template>

<script>
export default {
  name: 'TableHead'
}
</script>
